import React from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Button,
  Checkbox,
  DateRangePicker,
  Modal,
  MultiSelect,
  MultiSelectTable,
  Select,
  Table,
  TableWithHeader,
  Textfield,
} from "../../../components/core";
import { useLazyQuery, useQuery } from "@apollo/client";
import {
  AGENTS_WITH_FILTER,
  BRANCHES,
  BROADCAST_AGENT_WITH_FILTER,
  PARTNERS,
} from "../../../constants/graphql/partner-agent-queries";
import SendSMSModal from "./components/send-sms-modal";
import SendAppModal from "./components/send-app-modal";
import SendEmailModal from "./components/send-email-modal";
import sendApiRequest from "../../../api/broadcast-agent";
import { useSelector } from "react-redux";
import { Badge } from "primereact/badge";
import { InputText } from "primereact/inputtext";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import { formatDateYYYYMMDD } from "../../../algorithms/date";
function combineDateAndTime(dateString, timeString) {
  // Combine date and time strings into a single string
  const combinedString = `${dateString}T${timeString}:00`;

  // Create a Date object from the combined string
  const combinedDateTime = new Date(combinedString);

  // Get the ISO 8601 format string with time and timezone
  const isoString = combinedDateTime.toISOString();

  // Remove milliseconds and return the formatted string
  return isoString.slice(0, -5) + "Z";
}

const ID_STATUS_LIST = [
  "Unverified",
  "Verified",
  "Pending Verification",
  "Rejected",
];
const AGENT_STATUS_LIST = ["Suspended", "Active"];
const withoutLockerNameHeader = [
  // { header_name: "", header_key: "index" },
  {
    header_name: "Agent Name",
    header_key: "agentName",
  },
  {
    header_name: "Branch",
    // header_key: { k1: "partnerBranch", k2: "partnerBranch" },
    header_key: "partnerBranch",
  },
  { header_name: "Agent Status", header_key: "agentStatus" },
  { header_name: "Verified Status", header_key: "verifiedStatus" },
  { header_name: "Signup Date", header_key: "signupDate", tag: "date" },
  { header_name: "Mobile Number", header_key: "agentMobile" },
  { header_name: "Balance", header_key: "loadBalance" },
  // { header_name: "Locker Name", header_key: "lockerName" },
];
function formatDate(inputDate) {
  const options = { year: "numeric", month: "short", day: "numeric" };
  const date = new Date(inputDate);
  return date.toLocaleDateString("en-US", options);
}
function omitEmptyAndMinusOneFields(obj) {
  const result = {};
  for (const key in obj) {
    // Exclude null, undefined, empty string, and -1 values
    if (
      obj[key] !== null &&
      obj[key] !== undefined &&
      obj[key] !== "" &&
      parseInt(obj[key]) !== -1 && // Check for -1
      parseInt(obj[key]) !== -2 &&
      !(Array.isArray(obj[key]) && obj[key].length === 0) // Check for empty array
    ) {
      // result[key] = obj[key];

      if (key === "signupDateFrom" || key === "signupDateInto") {
        result[key] = formatDateYYYYMMDD(obj[key]);
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}

export default function BroadcastAgent() {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions,
  );
  // Local States
  const [selectedData, setSelectedData] = React.useState([]);
  const [scheduleBlastingFlag, setScheduleBlastingFlag] = React.useState(false);
  const [dateSchedule, setDateSchedule] = React.useState(new Date());
  const [searchCriteria, setSearchCriteria] = React.useState({
    operatorId: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "",
    firstName: "",
    lastName: "",
    agentMobile: "",
    partnerId: [],
    partnerBranchId: "-2",
    withApp: "-2",
    agentStatus: "-2",
    verifiedStatus: "-2",
    // signupDateFrom: "",
    // signupDateInto: "",
    signupDateFrom: new Date(),
    signupDateInto: new Date(),
  });
  const [branchList, setBranchList] = React.useState([]);
  const [partnerList, setPartnerList] = React.useState([]);
  const [searchData, setSearchData] = React.useState([]);
  const [headerValue, setHeaderValue] = React.useState("");
  const [searchFlag, setSearchFlag] = React.useState(false);

  const [sendSMSData, setSendSMSData] = React.useState({
    open: false,
    message: "",
    operatorId: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "",
    target: [],
    schedule: null,
    time: null,
  });
  const [sendAppData, setSendAppData] = React.useState({
    open: false,
    operatorId: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "",
    message: "",
    target: [],
    category: "-1",
    image: "",
    schedule: null,
    time: null,
    subject: "",
  });
  const [sendEmailData, setSendEmailData] = React.useState({
    open: false,
    operatorId: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user")).operator_id
      : "",
    message: "",
    target: [],
    schedule: null,
    time: null,
    subject: "",
  });
  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });
  //GQL

  const [agentsWithFilter, { data, loading }] = useLazyQuery(
    BROADCAST_AGENT_WITH_FILTER,
  );
  const partners = useQuery(PARTNERS, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const branches = useQuery(BRANCHES, {
    fetchPolicy: "no-cache",
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  // Handle Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchCriteria((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = () => {
    setSearchFlag(true);
    let filteredSearchCriteria = omitEmptyAndMinusOneFields(searchCriteria);
    console.log({ filteredSearchCriteria, partnerList });
    setHeaderValue(
      `
			  Search result for 
			  ${
          filteredSearchCriteria.verifiedStatus
            ? filteredSearchCriteria.verifiedStatus === -1
              ? ""
              : ID_STATUS_LIST[
                  filteredSearchCriteria.verifiedStatus
                ].toUpperCase()
            : "ALL ID status"
        }

			  ${
          filteredSearchCriteria.agentStatus
            ? filteredSearchCriteria.agentStatus === "-1"
              ? "BLOCKED"
              : AGENT_STATUS_LIST[
                  filteredSearchCriteria.agentStatus
                ].toUpperCase()
            : "ALL agent status,"
        }
			  
			  ${Object.keys(filteredSearchCriteria).length === 1 ? "ALL agents" : ""}

			  ${
          filteredSearchCriteria.firstName || filteredSearchCriteria.lastName
            ? "agent "
            : ""
        }
			  ${
          filteredSearchCriteria.firstName
            ? filteredSearchCriteria.firstName.toUpperCase()
            : ""
        }
			  ${" "}
			  ${
          filteredSearchCriteria.lastName
            ? filteredSearchCriteria.lastName.toUpperCase()
            : ""
        }  
			  
			  ${
          Object.keys(filteredSearchCriteria).length >= 2 &&
          !(filteredSearchCriteria.firstName || filteredSearchCriteria.lastName)
            ? "agents"
            : ""
        }

			  ${
          parseInt(filteredSearchCriteria.withApp) > -1
            ? parseInt(filteredSearchCriteria.withApp) === 1
              ? "WITH APP"
              : "WITH NO APP"
            : "WITH OR WITHOUT APP"
        }
			  ${
          filteredSearchCriteria.agentMobile
            ? "using +63" + filteredSearchCriteria.agentMobile
            : ""
        }

			  ${" "}

			  of
			${
        Array.isArray(filteredSearchCriteria.partnerId) &&
        filteredSearchCriteria.partnerId.length > 0
          ? partnerList
              .filter((partner) =>
                filteredSearchCriteria.partnerId.some(
                  (id) => parseInt(id.value) === parseInt(partner.value),
                ),
              )
              .map((partner) => partner.label.toUpperCase())
              .join(", ")
          : "ALL partners"
      }

of
			  ${
          branchList.find(
            (branch) => branch.value === filteredSearchCriteria.partnerBranchId,
          )
            ? branchList
                .find(
                  (branch) =>
                    branch.value === filteredSearchCriteria.partnerBranchId,
                )
                .name.toUpperCase() + " "
            : "ALL branches"
        }
			  ${
          filteredSearchCriteria.signupDateFrom !== undefined &&
          filteredSearchCriteria.signupDateInto !== undefined
            ? `
			  ${
          filteredSearchCriteria.signupDateFrom
            ? `From ${filteredSearchCriteria.signupDateFrom}`
            : ``
        }
			  ${
          filteredSearchCriteria.signupDateInto
            ? `to ${filteredSearchCriteria.signupDateInto}`
            : `Onwards`
        }
			  `
            : ``
        }
			  `,
    );
    if (filteredSearchCriteria.partnerId) {
      let newValue = filteredSearchCriteria.partnerId.map((data) => {
        return data.value;
      });
      filteredSearchCriteria.partnerId = newValue;
    }
    console.log(filteredSearchCriteria);
    agentsWithFilter({ variables: filteredSearchCriteria });
  };
  const resetAgentFilter = () => {
    setSearchCriteria({
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
      firstName: "",
      lastName: "",
      agentMobile: "",
      partnerId: [],
      partnerBranchId: "-2",
      withApp: "-2",
      agentStatus: "-2",
      verifiedStatus: "-2",
      // signupDateFrom: "",
      // signupDateInto: "",
      signupDateFrom: new Date(),
      signupDateInto: new Date(),
    });
  };

  const buildBroadcastFilter = () => {
    const filter = {};
    if (searchCriteria.partnerId.length === 1) {
      filter.partner_id = parseInt(searchCriteria.partnerId[0].value);
    }
    const branchId = parseInt(searchCriteria.partnerBranchId);
    if (!isNaN(branchId) && branchId > 0) {
      filter.partner_branch_id = branchId;
    }
    if (searchCriteria.agentMobile) {
      filter.agent_mobile = `63${searchCriteria.agentMobile}`;
    }
    const agentStatus = parseInt(searchCriteria.agentStatus);
    if (!isNaN(agentStatus) && agentStatus > -2) {
      filter.agent_status = agentStatus;
    }
    const verifiedStatus = parseInt(searchCriteria.verifiedStatus);
    if (!isNaN(verifiedStatus) && verifiedStatus >= 0) {
      filter.verified_status = verifiedStatus;
    }
    if (searchCriteria.firstName) filter.first_name = searchCriteria.firstName;
    if (searchCriteria.lastName) filter.last_name = searchCriteria.lastName;
    if (searchCriteria.signupDateFrom) {
      filter.signup_date_from = formatDateYYYYMMDD(
        searchCriteria.signupDateFrom,
      );
    }
    if (searchCriteria.signupDateInto) {
      filter.signup_date_upto = formatDateYYYYMMDD(
        searchCriteria.signupDateInto,
      );
    }
    const withApp = parseInt(searchCriteria.withApp);
    if (!isNaN(withApp) && withApp >= 0) {
      filter.with_app = withApp;
    }
    return filter;
  };

  // Use Effects
  React.useEffect(() => {
    if (partners.data) {
      let tempVar = [];
      partners.data.partners.forEach((element) => {
        tempVar.push({
          value: element.partnerId,
          label: element.companyNickname,
        });
      });
      setPartnerList(tempVar);
    }
  }, [partners.data]);
  React.useEffect(() => {
    if (branches.data) {
      let tempVar = [];
      branches.data.partnerBranches.forEach((element) => {
        tempVar.push({
          value: element.partnerBranchId,
          name: element.partnerBranch,
        });
      });
      setBranchList(tempVar);
    }
  }, [branches.data]);
  React.useEffect(() => {
    let variables = {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    };
    if (searchCriteria.partnerId.length === 1) {
      variables.partnerId = searchCriteria.partnerId[0].value;
      console.log(variables);
      branches.refetch(variables);
    } else {
      setSearchCriteria((prev) => ({ ...prev, partnerBranchId: "-1" }));
    }

    // .then((data) => {
    // 	if (data.data) {
    // 		console.log(data.data.partnerBranches);
    // 		let tempVar = [];
    // 		data.data.partnerBranches.forEach((element) => {
    // 			tempVar.push({
    // 				value: element.partnerBranchId,
    // 				name: element.partnerBranch,
    // 			});
    // 		});
    // 		setBranchList(tempVar);
    // 	}
    // });
  }, [searchCriteria.partnerId]);
  React.useEffect(() => {
    if (data) {
      let tempVar = [];
      data.broadcastAgentsWithFilter.forEach((element) => {
        tempVar.push({
          agentMobile: formatNumbers(element.agentMobile),
          agentStatus: AGENT_STATUS_LIST[element.agentStatus],
          agentName:
            !element.firstName && !element.lastName && !element.middleName
              ? "Unspecified name"
              : `${element.firstName} ${element.lastName} ${element.suffixName}`,
          loadBalance: element.loadBalance,
          partnerAgentId: element.partnerAgentId,
          partnerBranch: element.partnerBranch.partnerBranch,
          signupDate: element.signupDate,
          verifiedStatus:
            element.verifiedStatus === "-1"
              ? "Blocked"
              : ID_STATUS_LIST[element.verifiedStatus],
        });
      });
      setSearchData(tempVar);
    }
  }, [data]);

  console.log({ searchData });
  return (
    <ContentContainer containerTitle={"Broadcast Agents"}>
      <div className="mb-2"></div>
      <div className="w-4/5 grid grid-cols-5 gap-2">
        {/*  */}
        <div className="">
          <p className="text-base mt-2">Name:</p>
        </div>
        <div className=" col-span-2">
          <Textfield
            type="text"
            name="lastName"
            value={searchCriteria.lastName}
            onChange={handleChange}
            placeholder="Surname"
          />
        </div>
        <div className="col-span-2">
          <Textfield
            type="text"
            name="firstName"
            value={searchCriteria.firstName}
            onChange={handleChange}
            placeholder="First name"
          />
        </div>
        {/*  */}
        <div className="col-span-2">
          <p className="text-base mt-2">Registered mobile number: </p>
        </div>
        <div className="col-span-3 flex">
          <p className="mt-auto mb-auto mr-1">+63</p>
          {/* <Textfield
						type="text"
						name="agentMobile"
						value={searchCriteria.agentMobile}
						onChange={handleChange}
						maxLength={10}
						placeholder="9xxxxxxxxx"
						className="appearance-none"
					/> */}
          <InputText
            keyfilter={"int"}
            maxLength={10}
            placeholder={"9XXXXXXXXX"}
            className={
              "my-auto h-10 border-2 focus:outline-yellow-400 rounded-md p-1"
            }
            name="agentMobile"
            value={searchCriteria.agentMobile}
            onChange={handleChange}
          />
        </div>
        {/*  */}
        <div className="col-span-1">
          <p className="text-base mt-2">Verified Status: </p>
        </div>
        <div className="col-span-3">
          <Select
            items={[
              { value: "0", name: "Unverified" },
              { value: "2", name: "Pending verification" },
              { value: "1", name: "Verified" },
              { value: "3", name: "Rejected" },
            ]}
            defaultOption={{ value: -"2", name: "-- All --" }}
            onChange={handleChange}
            value={searchCriteria.verifiedStatus}
            name="verifiedStatus"
          />
        </div>
        <div className="col-span-1"></div>
        <div className="col-span-1">
          <p className="text-base mt-2">Agent Status: </p>
        </div>
        <div className="bg-slate-50 col-span-3">
          <Select
            items={[
              { value: -"1", name: "Blocked" },
              { value: "0", name: "Suspended" },
              { value: "1", name: "Active" },
            ]}
            defaultOption={{ value: -"2", name: "-- All --" }}
            onChange={handleChange}
            value={searchCriteria.agentStatus}
            name="agentStatus"
          />
        </div>
        <div className="col-span-1"></div>
        <div className="col-span-1">
          <p className="text-base mt-2">With App: </p>
        </div>
        <div className="bg-slate-50 col-span-3">
          <Select
            items={[
              { value: "1", name: "Yes" },
              { value: "0", name: "No" },
            ]}
            defaultOption={{ value: -"2", name: "-- All --" }}
            onChange={handleChange}
            value={searchCriteria.withApp}
            name="withApp"
          />
        </div>
        <div className="col-span-1"></div>
        <div className="col-span-1">
          <p className="text-base mt-2">Signup Date: </p>
        </div>
        <div className="col-span-3">
          {/* <DateRangePicker
						className={""}
						onChange={handleChange}
						startDate={searchCriteria.signupDateFrom}
						endDate={searchCriteria.signupDateInto}
					/> */}
          <PrimereactDateRange
            onChange={handleChange}
            startDate={searchCriteria.signupDateFrom}
            endDate={searchCriteria.signupDateInto}
            readOnlyInput={true}
            max={new Date()} // Today's date as the maximum
            min={new Date("2021-01-01")}
          />
        </div>
        <div className="col-span-1"></div>
        <div className="col-span-1">
          <p className="text-base mt-2">Partner: </p>
        </div>
        <div className="bg-slate-50 col-span-3">
          <MultiSelect
            defaultOption={{ value: "-2", name: "-- Select a Partner --" }}
            items={partnerList}
            onChange={handleChange}
            value={searchCriteria.partnerId}
            name="partnerId"
          />
          {/* <Select
						defaultOption={{ value: "-2", name: "-- Select a Partner --" }}
						items={partnerList}
						onChange={handleChange}
						value={searchCriteria.partnerId}
						name="partnerId"
					/> */}
        </div>
        <div className="col-span-1"></div>
        {/*  */}
        <div className="col-span-1">
          <p className="text-base mt-2">Branch: </p>
        </div>
        <div className="bg-slate-50 col-span-3">
          <Select
            disabled={searchCriteria.partnerId.length !== 1}
            items={branchList}
            value={
              searchCriteria.partnerId === "-2"
                ? "-2"
                : searchCriteria.partnerBranchId
            }
            onChange={handleChange}
            defaultOption={{ value: "-2", name: "-- Select a Branch --" }}
            name="partnerBranchId"
          />
        </div>
        <div className="col-span-1 flex"></div>
        {/* <div className="bg-slate-50 col-span-3"></div> */}
        <div className="col-span-2 flex gap-4">
          <Button
            onClick={handleSubmit}
            className={"w-full h-full mr-2 p-2"}
            value="Search"
          />
          <u
            className="flex hover:text-blue-500 cursor-pointer"
            onClick={resetAgentFilter}
          >
            <i className="fas fa-undo my-auto"></i>
            <p className="my-auto ml-1">Reset</p>
          </u>
        </div>
      </div>
      <div className="mt-10"></div>
      {/* ---------------------- */}
      {searchFlag && (
        <>
          <p>
            Total records:<b> {searchData.length}</b>
          </p>

          <div className="bg-primary-primaryYellow w-full border-stone-400 border-b-2 text-center">
            <p className="font-bold text-lg m-auto p-2">{headerValue}</p>
          </div>

          {accessPermission.broadcastAgents == 1 ||
          accessPermission.broadcastAgents === "1" ? (
            <Table headers={withoutLockerNameHeader} items={searchData} />
          ) : (
            <>
              {searchData.length > 1000 ? (
                <Table headers={withoutLockerNameHeader} items={searchData} />
              ) : (
                <MultiSelectTable
                  id={"cleanup-table"}
                  items={searchData}
                  headers={{
                    verifiedStatus: "Verified Status",
                    agentName: "Agent Name",
                    partnerBranch: "Branch",
                    agentStatus: "Agent Status",
                    signupDate: "Signup Date",
                    agentMobile: "Mobile Number",
                    loadBalance: "Balance",
                    lockerName: "Locker Name",
                  }}
                  customField={{ tag: "date", field: "signupDate" }}
                  keyToSelect="partnerAgentId"
                  setSelectedData={setSelectedData}
                  customColumnTemplates={{
                    verifiedStatus: (rowData) => {
                      console.log({ rowData });
                      return (
                        <Badge
                          className={`flex justify-center text-secondary-purpleGray items-center ${
                            rowData.verifiedStatus === "Verified"
                              ? "bg-green-400"
                              : rowData.verifiedStatus === "Rejected"
                                ? "bg-red-400"
                                : rowData.verifiedStatus ===
                                    "Pending Verification"
                                  ? "bg-orange-400"
                                  : rowData.verifiedStatus === "Unverified"
                                    ? "bg-gray-400"
                                    : "bg-blue-300"
                          } p-2 rounded`}
                          value={
                            rowData.verifiedStatus
                              ? rowData.verifiedStatus
                              : "Unknown"
                          }
                        ></Badge>
                      );
                    },
                  }}
                />
              )}
            </>
          )}

          {searchData.length > 0 && (
            <>
              <hr className="my-4"></hr>
              <div className="w-2/3 mx-auto grid grid-cols-3 gap-4">
                <Button
                  className={"p-2"}
                  value={"Send SMS"}
                  disabled={
                    accessPermission.broadcastAgents === "1" ||
                    accessPermission.broadcastAgents === 1
                  }
                  onClick={() => {
                    const targets = searchData.map(
                      (element) => element.partnerAgentId,
                    );

                    setSendSMSData((prev) => ({
                      ...prev,
                      open: true,
                      target: targets,
                    }));
                  }}
                />
                <Button
                  className={"p-2"}
                  value={"Send APP Message"}
                  disabled={
                    accessPermission.broadcastAgents === "1" ||
                    accessPermission.broadcastAgents === 1
                  }
                  onClick={() => {
                    const targets = searchData.map(
                      (element) => element.partnerAgentId,
                    );

                    setSendAppData((prev) => ({
                      ...prev,
                      open: true,
                      target: targets,
                    }));
                  }}
                />
                <Button
                  className={"p-2"}
                  value={"Send Email"}
                  disabled={
                    accessPermission.broadcastAgents === "1" ||
                    accessPermission.broadcastAgents === 1
                  }
                  onClick={() => {
                    const targets = searchData.map(
                      (element) => element.partnerAgentId,
                    );

                    setSendEmailData((prev) => ({
                      ...prev,
                      open: true,
                      target: targets,
                    }));
                  }}
                />
              </div>
            </>
          )}
        </>
      )}
      <SendSMSModal
        header={`SMS Message Notification`}
        open={sendSMSData.open}
        data={sendSMSData}
        selectedData={selectedData}
        onChange={(e) => {
          const { name, value } = e.target;
          setSendSMSData((prev) => ({ ...prev, [name]: value }));
        }}
        onSubmit={() => {
          let selectedAgentId = selectedData.map((data) => {
            return data.partnerAgentId;
          });
          let apiParameter = {
            operator_id: parseInt(searchCriteria.operatorId),
            filter: buildBroadcastFilter(),
            message_type_no: 0,
            sms_message: {
              content: sendSMSData.message,
            },
            partner_agent_ids:
              selectedAgentId.length === 0 || searchData.length > 1000
                ? []
                : selectedAgentId.map((id) => parseInt(id)),
          };
          if (sendSMSData.schedule && sendSMSData.time) {
            apiParameter.schedule_at = combineDateAndTime(
              sendSMSData.schedule,
              sendSMSData.time,
            );
          }
          console.log(apiParameter);
          sendApiRequest(apiParameter)
            .then((data) => {
              console.log(data);
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                title: "Success",
                message: "Successfully broadcast SMS to agents.",
                open: true,
                actions: (
                  <div className="gap-2 w-full mx-auto">
                    <Button
                      onClick={() => setValidation({ open: false })}
                      value={"OK"}
                      className={"p-2 w-full"}
                    />
                  </div>
                ),
              });
            })
            .catch((e) =>
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: "Error",
                message: "Error sending broadcast message to agents.",
                open: true,
                actions: (
                  <div className="gap-2 w-full mx-auto">
                    <Button
                      onClick={() => setValidation({ open: false })}
                      value={"OK"}
                      className={"p-2 w-full"}
                    />
                  </div>
                ),
              }),
            )
            .finally(() => {
              setSendSMSData((prev) => ({ ...prev, open: false }));
            });
        }}
        onClose={() => {
          ///Alert muna if g mag discard
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/warning.png`,
            title: "Discard Message?",
            message: "Closing the pop up will discard all the changes you made",
            open: true,
            actions: (
              <div className="gap-2 w-full mx-auto flex flex-row">
                <Button
                  onClick={() => setValidation({ open: false })}
                  value={"GO BACK"}
                  className={"p-2 w-full"}
                />
                <Button
                  onClick={() => {
                    setValidation({ open: false });
                    setSendSMSData({
                      open: false,
                      message: "",
                      operatorId: localStorage.getItem("user")
                        ? JSON.parse(localStorage.getItem("user")).operator_id
                        : "",
                      target: [],
                    });
                  }}
                  value={"DISCARD"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        }}
      />
      <SendAppModal
        header={`App Message Notification`}
        open={sendAppData.open}
        data={sendAppData}
        selectedData={selectedData}
        onChange={(e) => {
          const { name, value } = e.target;
          setSendAppData((prev) => ({ ...prev, [name]: value }));
        }}
        onSubmit={() => {
          let selectedAgentId = selectedData.map((data) => {
            return data.partnerAgentId;
          });
          let apiParameter = {
            operator_id: parseInt(searchCriteria.operatorId),
            filter: buildBroadcastFilter(),
            message_type_no: 1,
            app_message: {
              subject: sendAppData.subject,
              content: sendAppData.message,
              image: sendAppData.image,
              user_message_type_no: parseInt(sendAppData.category) || 0,
            },
            partner_agent_ids:
              selectedAgentId.length === 0 || searchData.length > 1000
                ? []
                : selectedAgentId.map((id) => parseInt(id)),
          };
          if (sendAppData.schedule && sendAppData.time) {
            apiParameter.schedule_at = combineDateAndTime(
              sendAppData.schedule,
              sendAppData.time,
            );
          }
          console.log(apiParameter);
          sendApiRequest(apiParameter)
            .then((data) => {
              console.log(data);
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                title: "Success",
                message: "Successfully broadcast app message to agents.",
                open: true,
                actions: (
                  <div className="gap-2 w-full mx-auto">
                    <Button
                      onClick={() => setValidation({ open: false })}
                      value={"OK"}
                      className={"p-2 w-full"}
                    />
                  </div>
                ),
              });
            })
            .catch((e) =>
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: "Error",
                message: "Error sending broadcast message to agents.",
                open: true,
                actions: (
                  <div className="gap-2 w-full mx-auto">
                    <Button
                      onClick={() => setValidation({ open: false })}
                      value={"OK"}
                      className={"p-2 w-full"}
                    />
                  </div>
                ),
              }),
            )
            .finally(() => {
              setSendAppData((prev) => ({ ...prev, open: false }));
            });
        }}
        onClose={() => {
          ///Alert muna if g mag discard
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/warning.png`,
            title: "Discard Message?",
            message: "Closing the pop up will discard all the changes you made",
            open: true,
            actions: (
              <div className="gap-2 w-full mx-auto flex flex-row">
                <Button
                  onClick={() => setValidation({ open: false })}
                  value={"GO BACK"}
                  className={"p-2 w-full"}
                />
                <Button
                  onClick={() => {
                    setValidation({ open: false });
                    setSendAppData({
                      open: false,
                      operatorId: localStorage.getItem("user")
                        ? JSON.parse(localStorage.getItem("user")).operator_id
                        : "",
                      message: "",
                      target: [],
                      category: -1,
                      image: "",
                      subject: "",
                    });
                  }}
                  value={"DISCARD"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        }}
      />
      <SendEmailModal
        header={`Email Message Notification`}
        open={sendEmailData.open}
        data={sendEmailData}
        selectedData={selectedData}
        onChange={(e) => {
          const { name, value } = e.target;
          setSendEmailData((prev) => ({ ...prev, [name]: value }));
        }}
        onSubmit={() => {
          let selectedAgentId = selectedData.map((data) => {
            return data.partnerAgentId;
          });
          let apiParameter = {
            operator_id: parseInt(searchCriteria.operatorId),
            filter: buildBroadcastFilter(),
            message_type_no: 2,
            email_message: {
              subject: sendEmailData.subject,
              content: sendEmailData.message,
            },
            partner_agent_ids:
              selectedAgentId.length === 0 || searchData.length > 1000
                ? []
                : selectedAgentId.map((id) => parseInt(id)),
          };
          if (sendEmailData.schedule && sendEmailData.time) {
            apiParameter.schedule_at = combineDateAndTime(
              sendEmailData.schedule,
              sendEmailData.time,
            );
          }
          console.log(apiParameter);
          sendApiRequest(apiParameter)
            .then((data) => {
              console.log(data);
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                title: "Success",
                message: "Successfully broadcast email to agents.",
                open: true,
                actions: (
                  <div className="gap-2 w-full mx-auto">
                    <Button
                      onClick={() => setValidation({ open: false })}
                      value={"OK"}
                      className={"p-2 w-full"}
                    />
                  </div>
                ),
              });
            })
            .catch((e) =>
              setValidation({
                icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                title: "Error",
                message: "Error sending broadcast message to agents.",
                open: true,
                actions: (
                  <div className="gap-2 w-full mx-auto">
                    <Button
                      onClick={() => setValidation({ open: false })}
                      value={"OK"}
                      className={"p-2 w-full"}
                    />
                  </div>
                ),
              }),
            )
            .finally(() => {
              setSendEmailData((prev) => ({ ...prev, open: false }));
            });
        }}
        onClose={() => {
          ///Alert muna if g mag discard
          setValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/warning.png`,
            title: "Discard Message?",
            message: "Closing the pop up will discard all the changes you made",
            open: true,
            actions: (
              <div className="gap-2 w-full mx-auto flex flex-row">
                <Button
                  onClick={() => setValidation({ open: false })}
                  value={"GO BACK"}
                  className={"p-2 w-full"}
                />
                <Button
                  onClick={() => {
                    setValidation({ open: false });
                    setSendEmailData({
                      open: false,
                      operatorId: localStorage.getItem("user")
                        ? JSON.parse(localStorage.getItem("user")).operator_id
                        : "",
                      message: "",
                      target: [],
                      subject: "",
                    });
                  }}
                  value={"DISCARD"}
                  className={"p-2 w-full"}
                />
              </div>
            ),
          });
        }}
      />
      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={validation.actions}
      />
    </ContentContainer>
  );
}

function formatNumbers(mobileNumber) {
  if (mobileNumber)
    if (mobileNumber.length > 2) return mobileNumber.toString().substring(2);
  return mobileNumber;
}
